import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import Scroll from '@/widgets/Scroll';
import FooterComponent from '@/layouts/Footer.vue';
import CursorComponent from '@/components/Cursor.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const wrapperRef = ref();
const store = useStore();

// onBeforeMount(async () => {
//   // This is a simple hack to block access by IP on the beta... Need to remove.
//   if (process.env.NODE_ENV !== 'development') {
//     const ipResponse = await fetch('https://api.ipify.org?format=json');
//     const { ip } = await ipResponse.json();
//     const safeList = ['86.16.13.81', '76.64.34.126', '158.180.192.10'];
//     if (!safeList.includes(ip)) {
//       window.location.href = 'https://www.kpmg.com';
//     }
//   }
// });

onMounted(async () => {
  await store.dispatch('getPosts');
  const scroll = new Scroll(wrapperRef.value as HTMLElement);
  store.commit('widgets/add', { instance: scroll, instanceKey: 'scroll' });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "wrapper",
    ref_key: "wrapperRef",
    ref: wrapperRef
  }, [
    _createVNode(_component_router_view),
    _createVNode(CursorComponent),
    _createVNode(FooterComponent)
  ], 512))
}
}

})